import styled from 'styled-components';
import media from '../../../../constants/media';
import theme from '../../../../constants/theme';
import { P } from '../../../base/typography';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;

	${media.desktopSmall`
		margin-top: 10px;
	`};
`;

export const ResultsWrapper = styled.div`
	width: 100%;
	${media.desktopSmall`
		padding-inline: 18%;
	`};
`;

export const ResultCount = styled.div`
	color: ${theme.colorsV2.grey6};
	font-size: 16px;
`;

export const ResultCountNumber = styled.span`
	font-size: 16px;
	color: ${theme.colorsV2.grey6};
	font-weight: ${theme.fonts.weight.medium};
`;

export const ResultItems = styled.div``;

export const NoResults = styled.div``;

export const NoResultsText = styled(P)``;
